import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, ListSection, ListItem } from 'medua-components';

/* eslint-disable */
@translate(['account', 'languages'])
export default class AccountSettings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      toggle: '',
    };
  }

  _onCheck(type) {
    if (this.state[type]) {
      this.setState({
        [type]: false
      })
    } else {
      this.setState({
        [type]: true
      })
    }
  }

  render() {

    return (
      <AppView
        color="dark"
        title={ this.props.t('account:settings.title') }>
          <ListSection margin>
            <ListItem
              key="1"
              title={ this.props.t('account:settings.language.title') }
              meta={ this.props.t('account:settings.language.text') + ' ' + this.props.t(`languages:${this.props.i18n.language}`) }
              url="/account/settings/language" />
            <ListItem
              key="2"
              title={ this.props.t('account:settings.devices') }
              url="/account/settings/devices" />
          </ListSection>
        </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/settings/index.jsx